<!--首页模块四-->
<template>
  <div style="font-family: Alibaba">
    <!--解决方案-->
    <div class="boxs_content">
      <div class="index_title">
        <h1>{{ cnNameFour }}</h1>
        <h6>{{ enNameFour }}</h6>
      </div>
      <el-row :span="24" class="box-width carbon background_img">
        <a href="#" @click='handleFourClick()'>
          <el-col :md="12" :sm="12" :xs="24">
            <div style="text-align: center">
              <el-image
                style="height: 280px"
                :fit='fit'
                v-if='homeFourVo.fullPathUrl != null'
                :src='homeFourVo.fullPathUrl'
              />
            </div>
          </el-col>
          <el-col :md="12" :sm="12" :xs="24">
            <div>
              <h4 style="padding: 10px;font-weight: bold;font-size: 16px;text-align: center">{{ homeFourVo.title }}</h4>
              <div v-html="homeFourVo.briefIntroduction" class="htmlImgSize" style="color: #606266;padding: 10px"></div>
            </div>
          </el-col>
        </a>
      </el-row>
    </div>
  </div>
</template>
<script>
import { findEnNameOne, findHomeFour } from '@/api/zh'

export default {
  created () {
  },
  data () {
    return {
      enNameFour: '',
      cnNameFour: '',
      homeFourVo: {},
      fit: 'fill',
      url: require('@assets/images/index/chanping.png'),
      url1: require('@assets/images/index/chanping1.png'),
      url2: require('@assets/images/index/chanping2.png')
    }
  },
  mounted () {
    this.selectFour()
  },
  methods: {
    /** 查询英文名称 */
    selectEnName (cnEnNameId) {
      let that = this
      findEnNameOne(cnEnNameId).then(res => {
        let data = res.data
        that.enNameFour = data.enName
        that.cnNameFour = data.cnName
      })
    },
    async selectFour () {
      let that = this
      await findHomeFour().then(res => {
        if (res.data.cnEnNameId !== null) {
          that.selectEnName(res.data.cnEnNameId)
        }
        that.homeFourVo = res.data
      })
    },
    handleFourClick () {
      const routeData = this.$router.resolve({
        path: this.homeFourVo.linksVo.href,
        query: { tabId: this.homeFourVo.linksVo.id }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style scoped>
</style>
